/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Consents_TitleInputs */

const cs_clients_consents_title = /** @type {(inputs: Clients_Consents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhlasy`)
};

const en_clients_consents_title = /** @type {(inputs: Clients_Consents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consents`)
};

/**
* | output |
* | --- |
* | "Consents" |
*
* @param {Clients_Consents_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_consents_title = /** @type {((inputs?: Clients_Consents_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Consents_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_consents_title(inputs)
	return cs_clients_consents_title(inputs)
});